import React from "react";
import BulasikDeterjaniLuks from "../Components/product/BulasikDeterjaniLuks";
import PageHeader from "../Components/common/PageHeader";
import ProductSEO from "../Components/common/ProductSEO";
import { t } from "i18next";

function BulasikDeterjaniLuksPage() {
    return (
        <>
            <ProductSEO
                name="Bulaşık Deterjanı (Lüks)"
                description="Lüks serisi ile güçlü yağ çözme ve parlak sonuçlar."
                slug="bulasikdeterjaniluks"
                imagePath="assets/images/20-kg/5.webp"
            />
            <PageHeader title={t("BULAŞIK DETERJANI LÜKS")} />
            <BulasikDeterjaniLuks />
        </>
    );
}

export default BulasikDeterjaniLuksPage;